import axios from "axios";

declare function require(moduleName: string): unknown;

type LoaderAction = {
  payload: {
    loadCount: number;
  };
  type: string;
};

type LoaderStore = {
  dispatch: (action: LoaderAction) => unknown;
};

let setLoaderStatusAction: (isLoading: boolean) => LoaderAction;

try {
  ({ setLoaderStatusAction } = require("cortex/ui/src/redux-store/loader") as {
    setLoaderStatusAction: (isLoading: boolean) => LoaderAction;
  });
} catch (error) {
  if (error instanceof Error && !/Cannot find module/.test(error.message)) {
    throw error;
  }
  setLoaderStatusAction = (isLoading: boolean) => {
    return {
      payload: {
        loadCount: isLoading ? 1 : -1,
      },
      type: "loader::load-count::increment",
    };
  };
}

export function _errorHandler<TError, TResponse>(
  errorHandler: (err: TError) => TResponse,
  err: TError,
): Promise<never> {
  const response = errorHandler(err);

  return Promise.reject(response);
}

export function _hideLoader<TResponse>(
  store: LoaderStore,
  response: TResponse,
): TResponse {
  store.dispatch(setLoaderStatusAction(false));

  return response;
}

export function _showLoader<TResponse>(
  store: LoaderStore,
  response: TResponse,
): TResponse {
  store.dispatch(setLoaderStatusAction(true));

  return response;
}

/*
 * Configures xhr interception to display the loader on all xhr requests.
 */
export function configureAxiosLoader(store: LoaderStore): void {
  const hideLoader = <TResponse>(response: TResponse) => {
    return _hideLoader(store, response);
  };
  const errorHideLoader = <TError>(err: TError) => {
    return _errorHandler(hideLoader, err);
  };
  const showLoader = <TResponse>(response: TResponse) => {
    return _showLoader(store, response);
  };

  axios.interceptors.response.use(hideLoader, errorHideLoader);

  axios.interceptors.request.use(showLoader, errorHideLoader);
}
